module.exports = __webpack_public_path__ + "img/HappyPhoto9.068c6968.jpeg";